import { MealType } from 'common/MealTypeUtils';
import { StarV2 } from 'src/shared/design-system/Icon';
import { Appetizer } from './Appetizer';
import { Dessert } from './Dessert';
import { Drink } from './Drink';
import { Kids } from './Kids';
import { Main } from './Main';
import { Side } from './Side';

export const MEAL_TYPE_TO_ICON = {
  [MealType.Appetizer]: <Appetizer />,
  [MealType.Dessert]: <Dessert />,
  [MealType.Drink]: <Drink />,
  [MealType.Kids]: <Kids />,
  [MealType.Main]: <Main />,
  [MealType.Popular]: <StarV2 />,
  [MealType.Side]: <Side />,
};
